import { SubscriptionDetailTab } from "./tab-types";

/**
 * Bring your own enum!
 * The default is TabConfig<SubscriptionDetailTab>.
 */
export interface TabConfig<T> {
  keyword: T; // rename this enum to something more generic
  translationKeyword: string;
}

// some presets here
export const PAGE_TAB_CONFIG_DEFAULT: TabConfig<SubscriptionDetailTab>[] = [
  { keyword: SubscriptionDetailTab.CONFIG, translationKeyword: "Tabs.ConfigAndStats" },
  { keyword: SubscriptionDetailTab.GRAPHIC_VIEW, translationKeyword: "Tabs.GraphicView" },
];

export const PAGE_TAB_CONFIG_WITH_SYSTEM: TabConfig<SubscriptionDetailTab>[] = [
  { keyword: SubscriptionDetailTab.CONFIG, translationKeyword: "Tabs.ConfigAndStats" },
  { keyword: SubscriptionDetailTab.SYSTEM_STATS, translationKeyword: "Tabs.SystemStats" },
  { keyword: SubscriptionDetailTab.GRAPHIC_VIEW, translationKeyword: "Tabs.GraphicView" },
];
